// src/components/admin/command_center/SuperAdminRoute.jsx
//
// La guardia de la ruta del centro de mando.
//
// ── QUÉ CAMBIÓ EL 24-09-2026 ────────────────────────────────────────────────
// El correo autorizado estaba escrito a mano aquí dentro. Funcionaba mientras
// éste era el único sitio que lo sabía; al añadir el botón de la cabecera pasan
// a ser dos, y dos condiciones copiadas acaban separándose. Ahora las dos
// preguntan a `puertaDelCentroDeMando.js`, que es el único que lo sabe.
//
// Esto NO es la seguridad del CRM —el `user` de `localStorage` se edita en dos
// clics—: lo que protege de verdad es que todas las rutas `/api/admin/*` piden
// `get_admin_user` en el servidor y contestan 403 a cualquier otro. Ver la
// cabecera de `puertaDelCentroDeMando.js`.
import { Navigate, Outlet } from 'react-router-dom';
import { elDeLaSesionPuedeEntrar } from '../puertaDelCentroDeMando';

export default function SuperAdminRoute() {
  // Sin sesión, a iniciarla. Se distingue de «no autorizado» a propósito:
  // mandar a /dashboard a quien no ha entrado lo deja en un bucle.
  if (!localStorage.getItem('token')) {
    return <Navigate to="/login" replace />;
  }

  if (!elDeLaSesionPuedeEntrar()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
